import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  store = normalizeRoot(require('../store/index.js'), 'store/index.js')

  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../store/auth.js'), 'auth.js')
  resolveStoreModules(require('../store/credentials.js'), 'credentials.js')
  resolveStoreModules(require('../store/layout.js'), 'layout.js')
  resolveStoreModules(require('../store/server.js'), 'server.js')
  resolveStoreModules(require('../store/toast.js'), 'toast.js')
  resolveStoreModules(require('../store/earned-coupons/index.js'), 'earned-coupons/index.js')
  resolveStoreModules(require('../store/card/getters.js'), 'card/getters.js')
  resolveStoreModules(require('../store/earned-coupons/mutation-types.js'), 'earned-coupons/mutation-types.js')
  resolveStoreModules(require('../store/card/mutation-types.js'), 'card/mutation-types.js')
  resolveStoreModules(require('../store/card/mutations.js'), 'card/mutations.js')
  resolveStoreModules(require('../store/pot/actions.js'), 'pot/actions.js')
  resolveStoreModules(require('../store/pot/getters.js'), 'pot/getters.js')
  resolveStoreModules(require('../store/pot/mutation-types.js'), 'pot/mutation-types.js')
  resolveStoreModules(require('../store/pot/mutations.js'), 'pot/mutations.js')
  resolveStoreModules(require('../store/pot/state.js'), 'pot/state.js')
  resolveStoreModules(require('../store/review/actions.js'), 'review/actions.js')
  resolveStoreModules(require('../store/card/actions.js'), 'card/actions.js')
  resolveStoreModules(require('../store/review/mutation-types.js'), 'review/mutation-types.js')
  resolveStoreModules(require('../store/review/mutations.js'), 'review/mutations.js')
  resolveStoreModules(require('../store/review/state.js'), 'review/state.js')
  resolveStoreModules(require('../store/card/state.js'), 'card/state.js')
  resolveStoreModules(require('../store/shop/actions.js'), 'shop/actions.js')
  resolveStoreModules(require('../store/shop/getters.js'), 'shop/getters.js')
  resolveStoreModules(require('../store/shop/mutation-types.js'), 'shop/mutation-types.js')
  resolveStoreModules(require('../store/shop/mutations.js'), 'shop/mutations.js')
  resolveStoreModules(require('../store/shop/state.js'), 'shop/state.js')
  resolveStoreModules(require('../store/timeline/actions.js'), 'timeline/actions.js')
  resolveStoreModules(require('../store/timeline/getters.js'), 'timeline/getters.js')
  resolveStoreModules(require('../store/timeline/mutation-types.js'), 'timeline/mutation-types.js')
  resolveStoreModules(require('../store/timeline/mutations.js'), 'timeline/mutations.js')
  resolveStoreModules(require('../store/timeline/state.js'), 'timeline/state.js')
  resolveStoreModules(require('../store/trackers/state.js'), 'trackers/state.js')
  resolveStoreModules(require('../store/trackers/mutations.js'), 'trackers/mutations.js')
  resolveStoreModules(require('../store/review/getters.js'), 'review/getters.js')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
